import React from 'react'

export interface ViewPrivacySection {
    title: string
    content: string
    items?: string[]
    footer?: string
}

export interface ViewPrivacyPolicyProps {
    title: string
    sections: ViewPrivacySection[]
}

export const ViewPrivacyPolicy = (props: ViewPrivacyPolicyProps): JSX.Element => {
    return (
        <div className="text">
            <h1>{props.title}</h1>

            {props.sections.map((section, index) => (
                <section key={index} className="text">
                    <h2>{section.title}</h2>
                    <p style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: section.content }}></p>

                    {section.items && section.items.length > 0 && (
                        <ul>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex}>{item}</li>
                            ))}
                        </ul>
                    )}

                    {section.footer && (
                        <p style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: section.footer }}></p>
                    )}
                </section>
            ))}
        </div>
    )
}
